import { useState } from 'react'
import { useBoolean } from 'usehooks-ts'
import { LiteYouTubeEmbed } from './YTEmbed'

export const CalcsTour = ({
  showJumpLinks = true,
  title = 'See Omni in action',
}: {
  showJumpLinks?: boolean
  title?: string
}) => {
  const [playtime, setPlaytime] = useState(0)
  const { value, setTrue } = useBoolean()
  const moveVideoTime = (time: number) => {
    setPlaytime(time)
    setTrue()
  }

  return (
    <section id="video" className="wide">
      <h2 className="section-heading">{title}</h2>

      <article className="video-intro">
        <LiteYouTubeEmbed
          isEnabled={value}
          enable={setTrue}
          id="XWkhKirKQHU"
          title="Omni Analytics - Calculations in Omni"
          playtime={playtime}
        />
        {showJumpLinks && (
          <aside>
            <ul>
              <li onClick={() => moveVideoTime(163)}>
                <h5>(2:43)</h5>
                <h3>Promote calculations to your data model</h3>
                <p>
                  Define reusable metrics quickly without writing SQL or waiting
                  for the data team.
                </p>
              </li>
              <li onClick={() => moveVideoTime(233)}>
                <h5>(3:53)</h5>
                <h3>Using xlookup()</h3>
                <p>Quickly analyze data across workbook tabs with xlookup().</p>
              </li>
              <li onClick={() => moveVideoTime(344)}>
                <h5>(5:44)</h5>
                <h3>Fun use cases with Calculations</h3>
                <p>
                  Create custom markdown visualizations, use Calculations AI to
                  identify outliers, and more.
                </p>
              </li>
            </ul>
          </aside>
        )}
      </article>
    </section>
  )
}
